import React from 'react';
import { AlertTriangle, FileSearch, Upload, XCircle } from 'lucide-react';
export function FrictionQueue() {
  const issues = [{
    id: 1,
    type: 'Missing Document',
    description: 'BOL not found in ERP for PO# 99821',
    retailer: 'Dollar General',
    action: 'upload'
  }, {
    id: 2,
    type: 'Unreadable Handwriting',
    description: 'Cannot decipher signature qty on BOL',
    retailer: 'Walmart',
    action: 'manual'
  }, {
    id: 3,
    type: 'SKU Mismatch',
    description: 'Invoice SKU does not match Claim SKU',
    retailer: 'Amazon',
    action: 'map'
  }];
  return <div className="space-y-6" data-id="element-309">
      <div data-id="element-310">
        <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-311">
          Friction Queue
        </h2>
        <p className="text-slate-500 mt-1" data-id="element-312">
          Handle exceptions where AI needs human assistance.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-313">
        <div className="overflow-x-auto" data-id="element-314">
          <table className="w-full text-sm text-left" data-id="element-315">
            <thead className="bg-slate-50 text-slate-500 font-medium" data-id="element-316">
              <tr data-id="element-317">
                <th className="px-6 py-3" data-id="element-318">Issue Type</th>
                <th className="px-6 py-3" data-id="element-319">Description</th>
                <th className="px-6 py-3" data-id="element-320">Retailer</th>
                <th className="px-6 py-3 text-right" data-id="element-321">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-322">
              {issues.map(issue => <tr key={issue.id} className="hover:bg-slate-50 transition-colors" data-id="element-323">
                  <td className="px-6 py-4" data-id="element-324">
                    <div className="flex items-center space-x-2" data-id="element-325">
                      <AlertTriangle className="w-4 h-4 text-amber-500" data-id="element-326" />
                      <span className="font-medium text-slate-900" data-id="element-327">
                        {issue.type}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-328">
                    {issue.description}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-329">{issue.retailer}</td>
                  <td className="px-6 py-4 text-right" data-id="element-330">
                    {issue.action === 'upload' && <button className="inline-flex items-center px-3 py-1.5 border border-slate-300 shadow-sm text-xs font-medium rounded text-slate-700 bg-white hover:bg-slate-50" data-id="element-331">
                        <Upload className="w-3 h-3 mr-1.5" data-id="element-332" />
                        Upload BOL
                      </button>}
                    {issue.action === 'manual' && <button className="inline-flex items-center px-3 py-1.5 border border-slate-300 shadow-sm text-xs font-medium rounded text-slate-700 bg-white hover:bg-slate-50" data-id="element-333">
                        <FileSearch className="w-3 h-3 mr-1.5" data-id="element-334" />
                        Review Manually
                      </button>}
                    {issue.action === 'map' && <button className="inline-flex items-center px-3 py-1.5 border border-slate-300 shadow-sm text-xs font-medium rounded text-slate-700 bg-white hover:bg-slate-50" data-id="element-335">
                        <XCircle className="w-3 h-3 mr-1.5" data-id="element-336" />
                        Ignore
                      </button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}